import React from "react";
import styles from "../../createEvent.module.css";
import { TextInput } from "evergreen-ui";
import { DateTimeRangeComponent } from "../../../../Components/DateTimeRangeComponent/DateTimeRangeComponent";
import { CustomSelect } from "../../../../Components/CustomSelect/CustomSelect";
export const RegistrationDetail = ({
  selectedAudienceForm,
  audienceForm,
  handleChangeAudienceDropdown,
  setActiveRegistrationBtn,
  setParticipantRegistrationFieldModal,
  selectedAudienceFormDetails,
  setSelectedAudienceFormDetails,
}) => {
  const handleUpdate = (key, index) => {
    const list = [...selectedAudienceFormDetails];
    list[index][key] = list[index][key] == 0 ? 1 : 0;
    setSelectedAudienceFormDetails(list);
  };

  return (
    <div className={styles.mainDiv}>
      <div className={styles.titleDiv}>
        <p>Add a Form</p>
      </div>
      <div className={styles.displayFlexDiv2}>
        <div className={styles.selectFormDiv}>
          <label className={styles.labelFont}>Select Form</label>
          <br />
          <div style={{ marginTop: "12px" }}>
            <CustomSelect
              options={audienceForm}
              value={selectedAudienceForm}
              name="eventType"
              handleOnChangeDropdown={handleChangeAudienceDropdown}
              padding={"4px"}
              border={"none"}
              height={"150px"}
            />
          </div>
        </div>
        <div>
          <div
            className={styles.addBtnSecondry}
            onClick={() => {
              setActiveRegistrationBtn("addForm");
              setParticipantRegistrationFieldModal(true);
            }}
          >
            + Add new form
          </div>
        </div>
      </div>
      <div>
        <div className={styles.selectedAudienceFormDiv}>
          <p className={styles.selectedAudienceLabel}>
            {selectedAudienceForm?.label}
          </p>
          {Object.keys(selectedAudienceForm).length > 0 && (
            <div
              className={styles.addBtnSecondry}
              style={{ marginTop: "0px" }}
              onClick={() => {
                setActiveRegistrationBtn("addField");
                setParticipantRegistrationFieldModal(true);
              }}
            >
              + Add new field
            </div>
          )}
        </div>
      </div>
      <div className={styles.displayFlexDiv3}>
        {selectedAudienceFormDetails?.map((item, index) => {
          return item?.isDelete != 1 ? (
            <div key={index}>
              <div className={styles.detailItem}>
                <p>{item?.label}</p>
                <div
                  style={{ display: "flex", gap: "12px", cursor: "pointer" }}
                >
                  <div
                    onClick={() => {
                      handleUpdate("isVisible", index);
                    }}
                    className={styles.formIcon}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/${
                        process.env.REACT_APP_IMAGES
                      }${
                        item?.isVisible
                          ? "/hideIconActive.svg"
                          : "/hideIcon.svg"
                      }`}
                      alt="hide"
                    />
                  </div>
                  <div
                    onClick={() => {
                      handleUpdate("isDelete", index);
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_IMAGES}/deleteLogo.svg`}
                      alt="Delete"
                    />
                  </div>
                </div>
              </div>
              <p className={styles.mandatoryDiv}>
                Mandatory: {item?.isMandatory ? "Yes" : "No"}
              </p>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};
